import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssignment } from '../../../../state';
import { useGetTeamsQuery } from '../../../../../../services/TeamService';

const DefaultTeamEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);
  const { data: teams, isLoading, error } = useGetTeamsQuery({ status: undefined });

  const handleChange = (event: any) => {
    dispatch(updateAssignment({ defaultTeam: event.target.value }));
  };

  return (
    <FormControl size="small" sx={{ minWidth: 200 }} required>
      <InputLabel>Default Team *</InputLabel>
      <Select
        value={currentRecurringTask?.defaultTeam || ''}
        onChange={handleChange}
        label="Default Team *"
        disabled={isLoading || !!error}
      >
        {isLoading ? (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Loading teams...
          </MenuItem>
        ) : error ? (
          <MenuItem disabled>Error loading teams</MenuItem>
        ) : (
          teams?.map((team) => (
            <MenuItem key={team.id} value={team.id}>
              {team.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default DefaultTeamEdit;
